module.exports = __webpack_public_path__ + "static/media/status_ready.f3a21e06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/status_ready.jpg
// module id = 1881
// module chunks = 0